import { krdetailConstants } from '../../constants/krdetails.constants';

/** App-services iframe apps using { value, label, total? } — target hydration + automate-target gate. */
export const KPI_IFRAME_METRIC_TARGET_APP_IDS = [
  krdetailConstants.JIRA_KPI_ID,
  krdetailConstants.MONDAY_KPI_ID,
  krdetailConstants.AZURE_DEVOPS_KPI_ID,
  krdetailConstants.MS_PLANNER_KPI_ID,
  krdetailConstants.WRIKE_KPI_ID,
] as const;

export type KpiIframeMetricTargetAppId = typeof KPI_IFRAME_METRIC_TARGET_APP_IDS[number];

/** Marketplace integrations on the v2 metric contract (mirror PHP ExternalApp::EXTERNAL_METRIC_V2_APP_IDS). */
export const EXTERNAL_METRIC_V2_APP_IDS = [
  krdetailConstants.JIRA_KPI_ID,
  krdetailConstants.AZURE_DEVOPS_KPI_ID,
] as const;

export type ExternalMetricV2AppId = typeof EXTERNAL_METRIC_V2_APP_IDS[number];

/** Legacy wizard: number UoM apps that set target from iframe `total`. */
export const KPI_IFRAME_NUMBER_TOTAL_TARGET_APP_IDS = [
  krdetailConstants.JIRA_KPI_ID,
  krdetailConstants.AZURE_DEVOPS_KPI_ID,
  krdetailConstants.MS_PLANNER_KPI_ID,
  krdetailConstants.WRIKE_KPI_ID,
] as const;

/** Legacy wizard: percent UoM apps that set target from iframe `total`. */
export const KPI_IFRAME_PERCENT_TOTAL_TARGET_APP_IDS = [
  krdetailConstants.MONDAY_KPI_ID,
  krdetailConstants.AZURE_DEVOPS_KPI_ID,
  krdetailConstants.MS_PLANNER_KPI_ID,
  krdetailConstants.WRIKE_KPI_ID,
] as const;

const KPI_IFRAME_METRIC_TARGET_APP_ID_SET = new Set<number>(KPI_IFRAME_METRIC_TARGET_APP_IDS);

const EXTERNAL_METRIC_V2_APP_ID_SET = new Set<number>(EXTERNAL_METRIC_V2_APP_IDS);

export function isKpiIframeMetricTargetAppId(
  extAppId: number,
): extAppId is KpiIframeMetricTargetAppId {
  return KPI_IFRAME_METRIC_TARGET_APP_ID_SET.has(extAppId);
}

export function isExternalMetricV2AppId(
  extAppId: number,
): extAppId is ExternalMetricV2AppId {
  return EXTERNAL_METRIC_V2_APP_ID_SET.has(extAppId);
}
